
export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="hero" 
      className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20"
    >
      {/* Animated Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-900 via-gray-900 to-red-900">
        <div 
          className="absolute inset-0 opacity-30 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=Modern%20luxury%20real%20estate%20development%20with%20contemporary%20architecture%20featuring%20glass%20facades%20and%20elegant%20design%2C%20professional%20corporate%20photography%20with%20warm%20golden%20hour%20lighting%2C%20sophisticated%20urban%20skyline%20background%2C%20high-end%20property%20investment%20atmosphere%2C%20clean%20minimalist%20aesthetic%20with%20premium%20materials%2C%20architectural%20excellence%20showcasing%20innovation%20and%20quality%20craftsmanship&width=1920&height=1080&seq=hero-madia-main&orientation=landscape')`
          }}
        />
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-red-500/10 via-transparent to-blue-500/10" />
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-20 right-10 w-72 h-72 bg-blue-500/5 rounded-full blur-3xl" />
      <div className="absolute bottom-20 left-10 w-96 h-96 bg-red-500/5 rounded-full blur-3xl" />

      <div className="relative w-full max-w-7xl mx-auto px-6 lg:px-8 py-20">
        <div className="max-w-4xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 mb-8 bg-gradient-to-r from-red-500/20 to-blue-500/20 backdrop-blur-sm border border-blue-500/30 px-6 py-3 rounded-full">
            <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse" />
            <span className="text-blue-300 font-semibold text-sm tracking-wider uppercase">
              Premium Property Solutions
            </span>
          </div>
          
          {/* Main Heading */}
          <h2 className="text-6xl md:text-7xl lg:text-8xl font-bold text-white mb-8 leading-tight">
            We Build Trust,
            <br />
            <span className="bg-gradient-to-r from-red-500 via-purple-500 to-blue-500 bg-clip-text text-transparent">
              Not Just Buildings
            </span>
          </h2>
          
          {/* Description */}
          <p className="text-xl md:text-2xl text-gray-300 mb-12 leading-relaxed max-w-3xl">
            Madina Associates delivers exceptional property dealing and construction services with unmatched expertise, integrity, and commitment to excellence in every project we undertake.
          </p>
          
          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-5 mb-20">
            <button 
              onClick={scrollToContact}
              className="group relative bg-gradient-to-r from-red-600 to-blue-600 text-white px-10 py-5 rounded-xl hover:shadow-2xl hover:shadow-blue-500/50 transition-all duration-300 font-bold text-lg whitespace-nowrap cursor-pointer overflow-hidden"
            >
              <span className="relative z-10 flex items-center justify-center gap-2">
                Get Started Today
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
              </span>
              <div className="absolute inset-0 bg-gradient-to-r from-red-500 to-blue-500 opacity-0 group-hover:opacity-100 transition-opacity" />
            </button>
            <button 
              onClick={() => document.getElementById('properties')?.scrollIntoView({ behavior: 'smooth' })}
              className="group relative border-2 border-blue-500/50 text-blue-300 px-10 py-5 rounded-xl hover:bg-blue-600 hover:text-white hover:border-blue-600 transition-all duration-300 font-bold text-lg whitespace-nowrap cursor-pointer backdrop-blur-sm"
            >
              <span className="flex items-center justify-center gap-2">
                View Properties
                <i className="ri-building-line" />
              </span>
            </button>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-8 pt-12 border-t border-blue-500/20">
            <div className="group cursor-pointer">
              <div className="text-5xl md:text-6xl font-bold bg-gradient-to-r from-red-500 to-blue-500 bg-clip-text text-transparent mb-3 group-hover:scale-110 transition-transform">
                250+
              </div>
              <div className="text-gray-400 font-medium">Properties Sold</div>
            </div>
            <div className="group cursor-pointer">
              <div className="text-5xl md:text-6xl font-bold bg-gradient-to-r from-red-500 to-blue-500 bg-clip-text text-transparent mb-3 group-hover:scale-110 transition-transform">
                180+
              </div>
              <div className="text-gray-400 font-medium">Projects Completed</div>
            </div>
            <div className="group cursor-pointer">
              <div className="text-5xl md:text-6xl font-bold bg-gradient-to-r from-red-500 to-blue-500 bg-clip-text text-transparent mb-3 group-hover:scale-110 transition-transform">
                15+
              </div>
              <div className="text-gray-400 font-medium">Years Experience</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-blue-500/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-2 bg-blue-500 rounded-full" />
        </div>
      </div>
    </section>
  );
}
